module.exports = __webpack_public_path__ + "static/media/videocall.e1ebf06b.png";